module.exports = __webpack_public_path__ + "img/case-study-pshare.c0c3e7b6.png";